<template>
    <div class="accountformMobile">
      <img src="../../assets/image/account.png" class="accountBack">
      <div class="contentBack">
          <el-form :model="form" ref="form" :rules="formRules" label-position="left">
              <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Name of Organization" prop="account_nameEn">
                          <el-input  v-model="form.account_nameEn"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                      <el-form-item label="Website" prop="account_website">
                          <el-input  v-model="form.account_website"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                  <el-form-item label="Organization Type" prop="organization_type">
                      <div style="display: inline-block;width:100%">
                          <el-checkbox-group v-model="form.organization_type">
                              <div ><el-checkbox label="Oversea Education Intermediary" /></div>
                              <div ><el-checkbox label="Personal Work Studio" /></div>
                              <div ><el-checkbox label="Institution of Background Improvement" /></div>
                              <div ><el-checkbox label="School" /></div>
                              <div ><el-checkbox label="Others"/></div>
                          </el-checkbox-group>
                      </div>
                  </el-form-item>
              </div>
              <div class="row">
                  <el-form-item label="Where do you learn about EAE?" prop="know_sources">
                      <div style="display: inline-block;width:100%">
                          <el-radio-group v-model="form.know_sources">
                              <div style="width:500px;margin-bottom: 18px;"><el-radio label="Website Search" /></div>
                              <div style="width:500px;margin-bottom: 18px;"><el-radio label="Social Media" /></div>
                              <div style="width:500px;margin-bottom: 18px;"><el-radio label="Students’ Recommendation" /></div>
                              <div style="width:500px;margin-bottom: 18px;"><el-radio label="Recommendations of Cooperative Partners"/></div>
                              <div ><el-radio label="Others"/></div>
                          </el-radio-group>
                      </div>
                  </el-form-item>
              </div>
              <div class="row">
                  <div class="rowItem">
                      <el-form-item prop="account_country">
                          <template slot="label">
                              <span>Country/Region</span>
                              <el-tooltip effect="dark" placement="top" trigger="click" content="Select your school's country/region, regardless of your citizenship. For international students, this means your current school location. Registration levels are based on school location only.">
                                  <i class="el-icon-info" style="margin-left: 5px; color: #409EFF; cursor: pointer;"></i>
                              </el-tooltip>
                          </template>
                          <div>
                              <el-select v-model="form.account_country" style="width: 100%;" placeholder="Please select" @change="handleCountryChanged" filterable>
                                  <el-option v-for="(country, index) in countryList" :key="index"
                                      :label="country.country_en" :value="country.country_en"></el-option>
                              </el-select>
                              <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">Select your school's country/region, regardless of your citizenship. For international students, this means your current school location. Registration levels are based on school location only.</p>
                          </div>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Contact Address" prop="contact_address">
                          <el-input  v-model="form.contact_address"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                      <el-form-item label="Registrant’s First Name (in English)" prop="contact_givenName">
                          <el-input  v-model="form.contact_givenName"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                      <el-form-item label="Registrant’s Last Name (in English)" prop="contact_lastName">
                          <el-input  v-model="form.contact_lastName"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Registrant’s Mobile" prop="contact_mobile">
                          <el-input  v-model="form.contact_mobile"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                      <el-form-item label="Registrant’s IM (Please also specify the IM platform)" prop="contact_wechat">
                          <el-input  v-model="form.contact_wechat"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Registrant’s Email Address" prop="contact_email">
                          <el-input  v-model="form.contact_email"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                      <el-form-item label="Registrant’s Title" prop="contact_position">
                          <el-input  v-model="form.contact_position"></el-input>
                      </el-form-item>
                  </div>
              </div>
              <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Are you also the program adviser?" prop="contact_as_adviser">
                        <el-radio v-model="form.contact_as_adviser" label="YES"></el-radio>
                        <el-radio v-model="form.contact_as_adviser" label="NO"></el-radio>
                      </el-form-item>
                  </div>
              </div>
              <div v-if="form.contact_as_adviser == 'NO'">
              <div class="row" style="font-size: 16px;color: #333333;font-weight: bold;">Program Adviser</div>
              <div class="row" style="color:#666666">If you are not the adviser，please provide the adviser’s information in the following form.</div>
              <div class="row">
                  <div class="rowItem">
                        <el-form-item label="Advisor's First Name" prop="adviser_givenName">
                            <el-input v-model="form.adviser_givenName"  placeholder="Please input"></el-input>
                        </el-form-item>
                  </div>
              </div>
              <div class="row">
                  <div class="rowItem">
                    <el-form-item label="Advisor's Last Name" prop="adviser_lastName">
                                <el-input v-model="form.adviser_lastName"  placeholder="Please input"></el-input>
                            </el-form-item>
                  </div>
              </div>
              <div class="row">
                <div class="rowItem" >
                  <el-form-item label="Advisor's Position/Subject" prop="adviser_subject">
                                <el-input v-model="form.adviser_subject" placeholder="Please input"></el-input>
                            </el-form-item>
                  </div>
              </div>
              <div class="row">
                  <div class="rowItem">
                      <el-form-item label="Email" prop="adviser_email">
                        <el-input v-model="form.adviser_email"  placeholder="Please input"></el-input>
                      </el-form-item>
                  </div>
              </div>
            </div>
              <div class="row" style="margin-bottom:50px">
                  <span class="submit" @click="submit">Submit</span>
              </div>
          </el-form>
      </div>

      <AccountFormConfirmDialog
          :show.sync="showConfirmDialog"
          :email="form.contact_email"
          :highlightFields="confirmHighlightFields"
          :normalFields="confirmNormalFields"
          :themeColor="'#F55443'"
          @confirmed="doSubmit"
      />
    </div>
  </template>

<script>
import { saveAccountForm, getCountries, getExclusivePartners } from '../../api/eae'
import AccountFormConfirmDialog from '../../components/AccountFormConfirmDialog.vue'
import { exclusivePartnersMixin } from '../../utils/exclusivePartners'
import { checkAndConfirmName } from '../../utils/nameValidator'
import '../../assets/common/common.css'

export default {
  mixins: [exclusivePartnersMixin],
  components: { AccountFormConfirmDialog },
  data () {
    return {
      showConfirmDialog: false,
      form: {
        new_field: 'yes',
        account_nameEn: '',
        account_website: '',
        organization_type: [],
        know_sources: [],
        contact_wechat:'',
        contact_mobile:'',
        contact_address:'',
        contact_lastName: '',
        contact_givenName: '',
        contact_email: '',
        contact_position: '',
        adviser_lastName: '',
        adviser_givenName: '',
        adviser_subject: '',
        adviser_email: '',
        account_country: '',
      },
      countryList: [],
      formRules: {
                account_website: [{ required: true, message: "Please input", trigger: "blur" }],
                contact_mobile: [{ required: true, message: "Please input", trigger: "blur" }],
                contact_address: [{ required: true, message: "Please input", trigger: "blur" }],
                know_sources: [{ required: true, message: "Please select", trigger: "blur" }],
                contact_lastName: [{ required: true, message: "Please input", trigger: "blur" }],
                contact_givenName: [{ required: true, message: "Please input", trigger: "blur" }],
                contact_email: [
                    { required: true, message: "Please input", trigger: "blur" },
                    { type: 'email', message: "Please enter a valid email address", trigger: "blur" }
                ],
                contact_position: [{ required: true, message: "Please input", trigger: "blur" }],

                account_nameEn: [{ required: true, message: "Please input", trigger: "blur" }],
                organization_type: [{ required: true, message: "Please select", trigger: "blur" }],
                contact_as_adviser: [{ required: true, message: "Please select", trigger: "blur" }],
                adviser_givenName: [{ 
                    required: true, 
                    message: "Please input", 
                    trigger: "blur",
                    validator: (rule, value, callback) => {
                        if (this.form.contact_as_adviser === 'NO' && !value) {
                            callback(new Error('Please input'));
                        } else {
                            callback();
                        }
                    }
                }],
                adviser_lastName: [{ 
                    required: true, 
                    message: "Please input", 
                    trigger: "blur",
                    validator: (rule, value, callback) => {
                        if (this.form.contact_as_adviser === 'NO' && !value) {
                            callback(new Error('Please input'));
                        } else {
                            callback();
                        }
                    }
                }],
                adviser_subject: [{ 
                    required: true, 
                    message: "Please input", 
                    trigger: "blur",
                    validator: (rule, value, callback) => {
                        if (this.form.contact_as_adviser === 'NO' && !value) {
                            callback(new Error('Please input'));
                        } else {
                            callback();
                        }
                    }
                }],
                adviser_email: [
                    { 
                        required: true, 
                        message: "Please input", 
                        trigger: "blur",
                        validator: (rule, value, callback) => {
                            if (this.form.contact_as_adviser === 'NO' && !value) {
                                callback(new Error('Please input'));
                            } else {
                                callback();
                            }
                        }
                    },
                    { type: 'email', message: "Please enter a valid email address", trigger: "blur" }
                ],
                account_country: [{ required: true, message: "Please select", trigger: "blur" }]
            }
    }
  },
  computed: {
    confirmHighlightFields() {
      return [
        { label: 'Name', value: (this.form.contact_givenName + ' ' + this.form.contact_lastName).trim() },
        { label: 'Email', value: this.form.contact_email },
        { label: 'Country/Region', value: this.form.account_country }
      ].filter(f => f.value)
    },
    confirmNormalFields() {
      return [
        { label: 'Organization', value: this.form.account_nameEn },
        { label: 'Position', value: this.form.contact_position },
        { label: 'Website', value: this.form.account_website },
        { label: 'Address', value: this.form.contact_address },
      ].filter(f => f.value)
    }
  },
  mounted() {
    this.requestCountryList()
    this.fetchExclusivePartners('EAE')
  },
  methods: {
    requestCountryList() {
      getCountries().then((res) => {
        this.countryList = res.data
      })
    },
    handleCountryChanged() {
      this.checkExclusivePartner(this.form.account_country)
    },
    submit () {
      if(false){
        console.log('form :' +JSON.stringify(this.form))
        return
      }

      if (!this.validateExclusivePartnerBeforeSubmit(this.form.account_country)) {
        return
      }
      this.$refs.form.validate((val) => {
        if (val) {
          checkAndConfirmName(this, [
            { first: this.form.contact_givenName, last: this.form.contact_lastName, label: 'Registrant name' }
          ]).then(() => {
            this.showConfirmDialog = true
          }).catch(() => {})
        } else {
          this.$confirm('Please fill in the required information', 'Tips', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
            customClass: 'mobileConfirm'
          })
        }
      })
    },
    doSubmit() {
      saveAccountForm(this.form,'EAE').then(res => {
        if (res.data) {
          this.$confirm('Thank you for registering. We are processing your account setup and will reach out to you via email within 3-5 business days.', 'Tips', {
            showCancelButton:false,
            confirmButtonText: 'OK',
            type: 'success',
            customClass: 'mobileConfirm'
          })
        }
      })
    }
  }
}
</script>

  <style scoped lang="scss">
  .accountformMobile{
      width: 100%;
      font-family: "DDINAlternateRegular";
      overflow: hidden;
      box-sizing: border-box;
      overflow-y: scroll;
      background: url(../../assets/image/accountBack.png);
          background-position: 0 0;
          background-size: 100% 100%;
      .accountBack{
          width: 100%;
          display: block;
      }
      .contentBack{
        width: 100%;
        box-sizing: border-box;
      }
      .row{
          width: 90%;
          margin: 0 auto;
          justify-content: space-between;
          // margin-bottom: 20px;
          display: flex;
          .rowItem{
            width: 100%;
          }
      }
      .el-checkbox-group{
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
      }
      .el-radio-group{
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
      }
      .submit{
          padding: 10px 70px;
          background: #F55443;
          color: #fff;
          cursor: pointer;
      }
  }
  </style>
  <style lang="scss">
  .accountform{
      .el-form-item__label{
          font-size: 16px;
          color: #333333;
          font-weight: bold;
      }
      .el-checkbox__label{
          font-size: 16px;
          color: #666666;
      }
      .el-radio__label{
          font-size: 16px;
          color: #666666;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
          background-color: #F55443;
          border-color: #F55443;
      }
      .el-checkbox__input.is-checked+.el-checkbox__label{
          color: #F55443;
      }
      .el-radio__input.is-checked .el-radio__inner{
          background-color: #F55443;
          border-color: #F55443;
      }
      .el-radio__input.is-checked+.el-radio__label{
          color: #F55443;
      }
  }
  .mobileConfirm{
    width: 80%;
    .el-message-box__container{
        display: flex;
        .el-message-box__status{
            position: relative;
            flex-shrink: 0;
            transform:none
        }
        .el-message-box__message{
            padding-left: 10px;
        }
    }
  }
  </style>
